import { useMutation } from '@tanstack/react-query';
import {
  BidvVirtualAccountService,
  SyncTransactionsBidvVAEntity,
} from 'services/openapi';
import { BidvVAInquiryParams } from '../types';

export const useSyncTransactionsBidvVAMutation = () =>
  useMutation<SyncTransactionsBidvVAEntity, Error, BidvVAInquiryParams>({
    mutationFn: ({ vaPrefix, endCode, startDate, endDate }) =>
      BidvVirtualAccountService.bidvVaControllerSyncTransactions(
        vaPrefix,
        endCode,
        startDate,
        endDate,
      ),
    retry: 0,
  });
